"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const ExpandableItemHeader = ({ icon, heading, className, onClick, isExpanded, link }) => {
    const IconHeading = icon ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'icon-container' },
            react_1.default.createElement("img", { src: icon, alt: heading })),
        react_1.default.createElement("span", null, heading))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", null,
            react_1.default.createElement("strong", null, heading))));
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('expandable-item-header', className) },
        react_1.default.createElement(react_1.default.Fragment, null,
            link ? react_1.default.createElement(react_router_dom_1.NavLink, { to: link }, IconHeading) : react_1.default.createElement(react_1.default.Fragment, null, IconHeading),
            isExpanded !== undefined && (react_1.default.createElement("img", { src: isExpanded ? common_1.ICONS.chevron_drop_up : common_1.ICONS.chevron_drop_down, onClick: onClick, alt: 'expand' })))));
};
exports.default = ExpandableItemHeader;
